
















































import Global from '@/js/global.js'
import Scope from '@/views/atoms/Scope.vue'
import BasePageTemplate from '@/views/templates/tenugui/BasePageTemplate.vue'
import PopupEpisode3_1 from '@/views/templates/tenugui/PopupEpisode3_1.vue'
import PopupEpisode3_2 from '@/views/templates/tenugui/PopupEpisode3_2.vue'
import PopupEpisode3_3 from '@/views/templates/tenugui/PopupEpisode3_3.vue'

export default
  components: {
    BasePageTemplate
    PopupEpisode3_1
    PopupEpisode3_2
    PopupEpisode3_3
    Scope
  }

  data: () ->
    showPopup: 0
    showEpisodePopup: [0, 0, 0]
  computed: {
    top: () ->
      return document.querySelector('.space01').offsetTop - document.querySelector('.space01').offsetHeight
  }
  methods: {
    reshowQuiz: (e) ->
      @showPopup = 1
    startScrollFire: () ->
      console.log('test')
      @$emit('start_scroll')
      @$emit('scrollFire')
      result = await Global.checkPointHit('p2-15')
      if result
        return
      if @showPopup == 0
        @showPopup = 1
    close_popup: (code) ->
      @showPopup = code
    show_episode_popup: (index) ->
      @$set(@showEpisodePopup, index, 1)
    close_episode_popup: (index) ->
      @$set(@showEpisodePopup, index, 0)
    add_point: (point) ->
      @$emit('addPoint', point)
  }
